export default "__VITE_ASSET__9G$8MOy$__"